<template lang="pug">
.Rss
    Loader.Playlist__loader(v-if="loading")
    .Rss__content(v-else)
      RssList.Rss__content__list(
          :list="list"
          @select="select")

      v-dialog(v-model="dialog" width="87%")
        RssReader(
          v-bind="currentItem")
</template>
<script>
import Loader from "@/components/page-components/Loader.vue";
import RssList from "@/components/page-components/RssList.vue";
import RssReader from "@/components/page-components/RssReader.vue";
import webmms from "webmms-client";
import { set as setCookie, get as getCookie } from "es-cookie";
import parse from "url-parse";
import { setTimeout } from "timers";
import conf from '@/config/config';

export default {
  name: "Rss",
  props: ['pageParams'],
  components: {
    Loader,
    RssList,
    RssReader
  },
  data() {
    return {
      dialog: false,
      selected: false,
      current: 0,
      mms: webmms({
        wsurl: conf.wsurl,
        EiToken: getCookie("rss-EiToken") || "",
        SToken: getCookie("rss-SToken") || ""
      }),
      response: null,
      state: "",
      loading: true,
      params: {},
      config: {
        app: "",
        websockURL: "https://ws1.ypcloud.com",
        DDN:">h2/mustme/blog-mms-app",
        topic: "blog://mms",
        invokeFn: "getPosts",
        params: {
          tags: {
            default: "",
            reducer(v) {
              let data = [];
              if (typeof v === "string") {
                data = v.split(",");
              }

              return data.map(item => {
                if (typeof item !== "string") {
                  return `#${v.toString()}`;
                }

                return item[0] === "#" ? item : `#${item}`;
              });
            }
          }
        }
      }
    };
  },
  computed: {
    list() {
      return !this.response
        ? null
        : this.response.map(o => ({
            title: o.title.rendered,
            content: o.content.rendered
          }));
    },
    currentItem() {
      return this.list[this.current];
    }
  },
  created() {
    try {
      this.setParams();
      this.startMMS("", this.config.websockURL);
    } catch (e) {
      this.state = e.message;
    }
  },
  beforeDestroy() {
    this.removeEvent();
  },
  methods: {
    select(index) {
      this.current = index;
      this.dialog = true;
      this.selected = true;
    },
    setParams() {
      //const { query } = parse(window.location.href, true);
      const result = {};
      const { cmsddn: cmsDDN } = this.pageParams;

      if (cmsDDN) {
        this.config.topic = cmsDDN;
      }

      Object.entries(this.config.params).forEach(o => {
        const key = o[0];
        const value = o[1];
        const { required, reducer } = value;
        let param = this.pageParams[key];

        if (!param) {
          if (required) {
            throw new Error(`${key}是必要參數。範例：?${key}=xxx`);
          }

          if (value.default) {
            param = value.default;
          }
        }

        if (reducer) {
          param = reducer(param);
        }

        result[key] = param;
      });
      this.params = result;
    },
    startMMS() {
      const { app, websockURL } = this.config;
      this.removeEvent = this.mms.on("registered", async reply => {
        let {
          result: { DDN, EiToken, SToken }
        } = reply;

        setCookie("rss-EiToken", EiToken);
        setCookie("rss-SToken", SToken);

        let deviceInfo = {
          EiOwner: "",
          EiName: "rss",
          EiType: ".page",
          EiTag: "",
          EiLog: ""
        };

        await this.mms.setDeviceInfo(deviceInfo);
        await this.track(this.mms, 'rss', this.pageParams);
        await this.callGetPosts();
      });
    },
    async callGetPosts() {
      let { tags } = this.params;
      const { topic,DDN ,invokeFn: func } = this.config;
      let [{ Reply: res }] = await this.mms.callMMS({
        topic,
        DDN,
        func,
        payload: { tags, page: 1, per_page: 10 }
      });

      this.response = res === "" ? [] : res;
      this.loading = res === "" ? true : false;

      if (this.loading) {
        setTimeout(this.callGetPosts, 8000);
      }
    }
  }
};
</script>
<style lang="sass">
.Rss
  +size(100%, 100%)
  +flex
  position: relative
  &__content
    width: 100%
    overflow: hidden
</style>
